.header {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0 0 20px;
}

.titleRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.heading {
    margin: 0;
}

.list {
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: 10px;
    overflow: hidden;
    background: var(--exo-color-background);
}

.empty {
    display: flex;
    justify-content: center;
    padding: 48px 24px;
    border: 1px dashed var(--exo-color-border-secondary);
    border-radius: 10px;
}
